import styled from "styled-components"
import colors from "../colors"

export const TableWrapper = styled.div`
  width: 100%;
`

export const TableLine = styled.div`
  width: 1px;
  background-color: ${colors.halfWhite};
  flex-grow: 1;
  margin-bottom: 70px;
`
